import {atom} from 'recoil';

export const pendingEmailState = atom({
  key: 'emailReceivedState',
  default: false,
});
